enum TabPaths {
  Metrics = 'metrics',
  Tags = 'tags',
}

export default TabPaths;
